import { render, staticRenderFns } from "./BundlePeopleSection.vue?vue&type=template&id=fdeaa952"
import script from "./BundlePeopleSection.vue?vue&type=script&lang=js"
export * from "./BundlePeopleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports